<template>
  <div class="catalogView">
<!-- TODO: Включить фильтр    -->
     <CatalogButtonPanel v-if="false"/>
     <CatalogList/>

  </div>
</template>

<script>
import CatalogButtonPanel from "@/components/CatalogView/CatalogButtonPanel.vue";
import CatalogList from "@/components/CatalogView/CatalogList.vue";

export default {
  name: "CatalogView",
  components: {CatalogList, CatalogButtonPanel}
}
</script>


<style scoped lang="scss">
.catalogView {
  display: flex;
  gap: 24px;
  flex-direction: column;
}
</style>
